module.exports = __webpack_public_path__ + "media/images/icons/flags/AL-b5e44337e1946d820dead2e673550192.svg";